/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
import store from 'store';
import { AxiosResponse } from 'axios';
import { AUDIENCE_LISTS, AUDIENCE_LISTS_SEARCH, AUDIENCE_LISTS_DELETE, AUDIENCE_LISTS_SELECTION } from 'constants/types';
import { CLONE_LIST } from 'constants/types/audienceTypesNew';
import { getAudienceListsService, cloneListService, getAudienceListsNamesOnlyService } from 'modules/Services/AudienceService';
import { deleteListService } from 'modules/Services/AudienceServiceNew';
import { KeyValNum, objectToQueryParams } from 'utils';
import { IListsResponse, IAudienceAPIError, ICloneListResponse } from '../interface';

export const setAudienceListSearchTerm = (searchTerm: string) => {
  store.dispatch({
    type: AUDIENCE_LISTS_SEARCH.SET_SEARCH,
    payload: { searchTerm },
  });
};

export const resetAudienceSearchedList = () => {
  store.dispatch({
    type: AUDIENCE_LISTS_SEARCH.RESET,
  });
};

export const resetAudienceList = () => {
  store.dispatch({
    type: AUDIENCE_LISTS.LISTS_RESET,
  });
};

export const getAudienceListsAction = (params: { offset: number; limit: number }) => {
  const { limit, offset } = params;
  const queryParams = objectToQueryParams({ limit, offset });
  console.log('2');
  store.dispatch({
    type: AUDIENCE_LISTS.LOAD,
  });
  getAudienceListsService(queryParams)
    .then((res: AxiosResponse<IListsResponse>) => {
      const { data, success } = res.data;
      if (success) {
        if (data[0]?.lists?.length > 0) {
          store.dispatch({
            type: AUDIENCE_LISTS.SUCCESS,
            payload: {
              lists: data[0].lists,
              ...(offset === 0 && { totalLists: data[0].totalLists }),
              offset,
            },
          });
        }
      } else {
        store.dispatch({ type: AUDIENCE_LISTS.FAIL });
      }
    })
    .catch((err: IAudienceAPIError) => {
      console.log('Error in getAudienceListsService : ', err);
      // check added because if two request goes at the same time then the first request throw the
      // following error which changes the loading state in the redux due to which
      // a wrong message was rendered.
      if (err?.message !== 'Operation canceled due to new request.') {
        store.dispatch({
          type: AUDIENCE_LISTS.FAIL,
        });
      }
    });
};

export const getAudienceSearchedListsAction = (params: { offset: number; limit: number; search_by_list_name: string }) => {
  const queryParams = objectToQueryParams(params);
  const { offset } = params;
  console.log('getAudienceSearchedLists');
  setAudienceListSearchTerm(params.search_by_list_name);
  store.dispatch({
    type: AUDIENCE_LISTS_SEARCH.LOAD,
  });
  return new Promise((resolve, reject) => {
    getAudienceListsService(queryParams)
      .then((res: AxiosResponse<IListsResponse>) => {
        const { data, success, message } = res.data;
        if (success) {
          if (data[0]?.lists?.length > 0) {
            console.log('Success Case');
            store.dispatch({
              type: AUDIENCE_LISTS_SEARCH.SUCCESS,
              payload: {
                lists: data[0].lists,
                ...(offset === 0 && { totalLists: data[0].totalLists }),
                offset,
              },
            });
          } else {
            store.dispatch({
              type: AUDIENCE_LISTS_SEARCH.FAIL,
            });
          }
        } else {
          store.dispatch({
            type: AUDIENCE_LISTS_SEARCH.ERROR_SEARCH_TERM,
            payload: {
              message,
              success,
            },
          });
          store.dispatch({
            type: AUDIENCE_LISTS_SEARCH.ERROR_SEARCH_TERM_LOADING,
          });
        }
        resolve({ success: true });
      })
      .catch((err: IAudienceAPIError) => {
        console.log('Error in getSearchedAudienceListsService : ', err);
        if (err.message !== 'Operation canceled due to new request.') {
          store.dispatch({
            type: AUDIENCE_LISTS_SEARCH.FAIL,
          });
        }
        // eslint-disable-next-line
        reject({ success: false });
      });
  });
};

export const deleteAudienceListAction = (listIds: number[], isSearched: boolean) => {
  store.dispatch({
    type: AUDIENCE_LISTS_DELETE.LOAD,
  });
  return new Promise((resolve, reject) => {
    deleteListService(listIds)
      .then((res: AxiosResponse<IListsResponse>) => {
        console.log(isSearched);
        const { message, success } = res.data;
        if (res.data.success) {
          store.dispatch({
            type: AUDIENCE_LISTS_DELETE.SUCCESS,
            payload: {
              message,
              success,
              listIds,
              isSearched,
            },
          });

          setTimeout(() => {
            store.dispatch({
              type: AUDIENCE_LISTS_DELETE.RESET,
            });
          }, 3000);
          resolve({ success: true });
        } else {
          store.dispatch({
            type: AUDIENCE_LISTS_DELETE.FAIL,
          });
        }
      })
      .catch((err: IAudienceAPIError) => {
        console.log(err);
        store.dispatch({
          type: AUDIENCE_LISTS_DELETE.FAIL,
        });
        // eslint-disable-next-line
        reject({ success: false });
      });
  });
};

export const cloneListAction = (listId: string, isSearched: boolean) => {
  store.dispatch({
    type: CLONE_LIST.LOAD,
  });
  return new Promise((resolve, reject) => {
    cloneListService(listId)
      .then((res: AxiosResponse<ICloneListResponse>) => {
        const { message, success, data } = res.data;
        console.log(message, data, isSearched);
        if (success) {
          console.log(success);
          store.dispatch({
            type: CLONE_LIST.SUCCESS,
            payload: {
              success,
              message,
              listData: data[0]?.listDetail,
              listId,
              isSearched,
            },
          });
          resolve({ success });
          console.log(success);
        } else {
          console.log(success);
          store.dispatch({
            type: CLONE_LIST.FAIL,
          });
          // eslint-disable-next-line
          reject({ success });
        }
      })
      .catch((err) => {
        console.log(err);
        // eslint-disable-next-line
        reject({ success: false });
        store.dispatch({
          type: CLONE_LIST.FAIL,
        });
      });
  });
};

export const audienceListImportSuccessAction = (newLists: KeyValNum[]) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  // const serializedData: IListItem[] = serializeImportList(newLists);
  store.dispatch({
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    type: AUDIENCE_LISTS.IMPORT_LIST_SUCCESS,
    payload: { listItem: newLists[0], import: true },
  });
};

export const audienceListSelectionSetAction = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  store.dispatch({ type: AUDIENCE_LISTS_SELECTION.SET });
};

export const audienceListSelectionResetAction = () => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  store.dispatch({ type: AUDIENCE_LISTS_SELECTION.RESET });
};

// Reloads lists' listing (mailing_lists API called)
export const refreshLists = (isSearch?: boolean, searchTerm?: string) => {
  if (isSearch) {
    resetAudienceSearchedList();
    getAudienceSearchedListsAction({ limit: 20, offset: 0, search_by_list_name: searchTerm ?? '' })
      .then((res) => {
        console.log('res: ', res);
        resetAudienceList();
        getAudienceListsAction({ limit: 20, offset: 0 });
      })
      .catch((err) => {
        console.log('err: ', err);
      });
  } else {
    resetAudienceList();
    getAudienceListsAction({ limit: 20, offset: 0 });
  }
};

export const getListNames = () => {
  store.dispatch({
    type: AUDIENCE_LISTS.NAMES_LOAD,
  });
  getAudienceListsNamesOnlyService()
    .then((res) => {
      const { success, data } = res.data;
      if (success) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (data?.length > 0) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          const { lists } = data[0];
          store.dispatch({
            type: AUDIENCE_LISTS.NAMES_LOAD_SUCCESS,
            listsDataNames: lists,
            payload: { listsDataNames: lists },
          });
        }
      }
    })
    .catch(() => {
      store.dispatch({
        type: AUDIENCE_LISTS.NAMES_FAIL,
      });
    });
};
